import { __awaiter } from "tslib";
import { API } from 'aws-amplify';
import { resolve, reject } from '../response';
export default {
    get(farmId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let result = yield API.get('console', `farms/${farmId}/profile`, {});
                return resolve(result);
            }
            catch (e) {
                throw reject(e);
            }
        });
    },
    list() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let result = yield API.get('console', 'farms', {});
                return resolve(result);
            }
            catch (e) {
                throw reject(e);
            }
        });
    },
    create(options) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let result = yield API.post('console', 'farm/create', {
                    body: options
                });
                return resolve(result);
            }
            catch (error) {
                throw reject(error);
            }
        });
    },
    update(farmId, options) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let result = yield API.post('console', `farms/${farmId}/update`, {
                    body: options
                });
                return resolve(result);
            }
            catch (error) {
                throw reject(error);
            }
        });
    },
    remove(farmId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let result = yield API.del('console', `farms/${farmId}/delete`, {});
                return resolve(result);
            }
            catch (error) {
                throw reject(error);
            }
        });
    }
};
